import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AppLoaderService {

  private dataSubject = new Subject<boolean>(); // or BehaviorSubject

  data$: Observable<any> = this.dataSubject.asObservable(); // Expose as Observable

  show(): void {

    const existing =document.getElementById('loaderModalArea')

    if(existing){
      existing.remove();
    }

    const modal = document.createElement('div');
    modal.setAttribute('id', 'loaderModalArea');
    //modal.classList.add('custom-confirm-backdrop');
    modal.innerHTML = `
      <div  class="loader-overlay"><div class="loader"></div></div>
    `;
    document.body.appendChild(modal);

    //this.dataSubject.next(true);
  }

  hide(){

    document.getElementById('loaderModalArea')?.remove();

   // this.dataSubject.next(false);
  }


}
